import NamaAutomation from "@/utils/automation/NamaAutomation.ts";

// Exposed on every deployment so users can drive the UI from their own LLM tools. The helpers act
// inside the user's session through the same endpoints as the UI, so the server enforces the same
// permissions; outside debug mode setField also refuses fields the screen shows as disabled.
export function installNamaAutomation() {
  (window as any).__nama = NamaAutomation;
}
